<template>
    <!-- 上传文件 -->
    <el-dialog class="dialog" v-if="dialogUploadFiles" title="上传素材到" :visible.sync="dialogUploadFiles" :close-on-click-modal="false" top="15vh" >
        <el-radio-group class="filter-item" v-model="uploadRadio">
            <el-radio :label="1">上传到已有文件夹</el-radio>
            <el-radio :label="2">无需文件夹，直接上传</el-radio>
        </el-radio-group>

        <el-form :model="filesForm" :rules="rulesFiles" ref="filesForm" label-width="100px">
            <el-form-item label="上传到" prop="folderPid" v-if="uploadRadio == 1">
                <el-cascader size="small" key="1" v-model="filesForm.folderPid" :options="folderOptions" :props="propsFolder" :disabled="filderDisabled" filterable clearable placeholder="请选择已有文件夹" style="min-width:300px; width:50%"></el-cascader>
            </el-form-item>

            <el-form-item label="选择标签" prop="labelIds" v-else>
                <el-cascader size="small" key="2" v-model="filesForm.labelIds" :options="tagOptions" :props="props" filterable clearable collapse-tags placeholder="请选择标签" style="min-width:300px; width:50%"></el-cascader>
            </el-form-item>

            <el-form-item prop="file">
                <simple-uploader ref="uploader" @onSuccess="handleSuccess" @onRemove="handleRemove" :folderPid="filesForm.folderPid" style="min-width:400px; width:82%" :maxNum="50"></simple-uploader>

                <!-- <el-upload class="upload-demo" ref="upload" drag 
                    :action= "uploadUrl"
                    :multiple="true"
                    :show-file-list="true"
                    :limit="maxNum"
                    :file-list="filesForm.file"
                    :on-remove="handleRemove"
                    :on-error="handleError"
                    :on-exceed="handleExceed"
                    :on-success="handleSuccess"
                >
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                    <div slot="tip" class="el-upload__tip" style="font-size:10px;margin-top:5px;line-height: 16px;">最多上传10个文件,且单个文件不超过 1G</div>
                </el-upload> -->

            </el-form-item>
        </el-form>

        <div class="dialog-butn-box" style="margin: 30px 0 0">
            <el-button size="small" @click="dialogUploadFiles = false">取 消</el-button>
            <el-button size="small" type="primary" :loading="dialogLoading" :disabled="saveDisabled!=0" @click="handleSave">确 定</el-button>
        </div>

    </el-dialog>
</template>

<script>
import SimpleUploader from './simpleUploader.vue'
import {folderTreeByPid_ajax, choiceLabel_ajax,saveUploadFile_ajax} from '@File~/api/file'

export default {
    components:{SimpleUploader},
    props:{
        source:{
            type: String,
            default: ''
        }
    },

    data() {
        return {
            dialogUploadFiles: false,
            dialogLoading:false,
            uploadRadio: 1,
            floderOptions:[],
            saveDisabled:0,
            filesForm:{
                file:[],
                filesForm:[],
                folderPid:[]
            },
            rulesFiles:{
                folderPid:[{ required: true, message: '请选择已有文件夹', trigger: ['change','blur'] }],
                labelIds:[{ required: true, message: '请选择标签', trigger: ['change','blur'] }],
                file:[{ required: true, message: '请上传文件', trigger: ['change','blur']}]
            },

            folderOptions:[],
            propsFolder:{
                checkStrictly: true,
                expandTrigger: 'hover',
                value:'id',
                label:'folderName',
                children:'childList'
            },
            tagOptions:[],
            props:{ 
                multiple: true,
                expandTrigger: 'hover',
                value:'id',
                label:'name',
                children:'labelList'
            },

            maxNum:10,

            filderDisabled: false,

            breadcrumbList:[], // 面包屑导航

            uploadUrl: this.$store.getters.uploadUrl, // 上传文件地址

        }
    },

    watch: {
        uploadRadio(val) {
            if(val == 1) {
                this.getFolders()
                this.$nextTick(()=>{
                    this.$refs['filesForm'].clearValidate()
                })
            } else {
                this.getChoiceLabel()
                this.$nextTick(()=>{
                    this.$refs['filesForm'].clearValidate()
                })
            }
        },
        'filesForm.file'(val){
            this.saveDisabled = 0
            val.forEach(item => {
                if(!item.fileId){
                    this.saveDisabled++
                }
            })
        }

    },

    methods: {
        init(breadcrumbList) {

            this.dialogUploadFiles = true
            this.dialogLoading = false
            this.uploadRadio = 1
            this.saveDisabled = 0
            this.filderDisabled = false

            this.breadcrumbList = breadcrumbList
            
            this.filesForm = {
                file:[],
                filesForm:[],
                folderPid:[]
            }
            this.$nextTick(()=>{
                this.$refs['filesForm'].clearValidate()

                this.getFolders()

                if(breadcrumbList && breadcrumbList.length > 1) {
                    breadcrumbList.forEach((item,index) => {
                        if(index > 0) {
                            this.filesForm.folderPid.push(item.id)
                        }
                    })
                    this.filderDisabled = true
                }
            })
        },

        // 获取已有文件夹列表
        getFolders() {
            this.folderOptions = []
            const folderPid = this.$store.getters.currentRoute.meta.id
            folderTreeByPid_ajax(folderPid).then(response => {
                if(response.code == 1) {
                    this.folderOptions = response.data
                }
            })
        },

        // 获取新建文件夹 选择标签列表
        getChoiceLabel() {
            this.tagOptions = []
            choiceLabel_ajax().then(response => {
                if(response.code == 1) {
                    this.tagOptions = response.data
                }
            })
        },
        
        // 确定
        handleSave() {
            this.$refs['filesForm'].validate((valid) => {
                if (valid) {
                   this.dialogLoading = true
                    let projectIds = []
                    let taskIds = []
                    let labelIds = []
                    let file = []
                    if(this.uploadRadio == 2) {
                        this.filesForm.labelIds.forEach(item => {
                            if(item[0] == 'projectIds') {
                                projectIds.push(item[1])
                            }

                            if(item[0] == "taskIds") {
                                taskIds.push(item[1])
                            }

                            if(item[0].indexOf("labelType") > -1) {
                                labelIds.push(item[1])
                            }
                        })
                    }

                    console.log("========this.filesForm.file",JSON.parse(JSON.stringify(this.filesForm.file)))

                    this.filesForm.file.forEach(item => {
                        // file.push(item.response.data)
                        file.push(item.fileId)
                    })

                    const data = {
                        fileIds: file,
                        withLabel: this.uploadRadio,
                        userId: this.$store.getters.userId,
                        folderPid: (this.uploadRadio == 1 && this.filesForm.folderPid.length > 0) ? this.filesForm.folderPid[this.filesForm.folderPid.length-1] : this.$store.getters.currentRoute.meta.id,
                        projectIds: this.uploadRadio == 2 ? projectIds : [],
                        taskIds: this.uploadRadio == 2 ? taskIds : [],
                        labelIds: this.uploadRadio == 2 ? labelIds : []
                    }

                    saveUploadFile_ajax(data).then(response => {
                        this.dialogLoading = false
                        if(response.code == 1) {
                            this.saveDisabled = 0
                            this.$message({
                                message:"上传成功",
                                type: "success"
                            });

                            this.dialogUploadFiles = false
                            if(this.uploadRadio == 1) {
                                if(this.breadcrumbList.length > 1) {
                                    this.$emit('handleRefresh',this.breadcrumbList[this.breadcrumbList.length-1].id)
                                }
                            } else {
                                this.$emit('handleRefresh')
                            }
                            
                        }
                    })
                }
            })
        },

        // 上传文件成功
        handleSuccess(file,fileList) {
            // console.log('2222',this.$refs['uploader'].$refs['uploader'].fileList)
            this.filesForm.file = fileList
            if(this.filesForm.file.length > 0) {
                this.$refs['filesForm'].validateField('file')
            }
            this.saveDisabled = 0
            this.filesForm.file.forEach(item => {
                if(!item.fileId){
                    this.saveDisabled++
                }
            })

        },

        // 上传成功后删除
        handleRemove(fileList) {
            this.filesForm.file = fileList
        }
        
        // ============== element 上传 ===========
        // 监听成功获取文件
        // handleSuccess(response, file, fileList) {
        //     console.log('监听上传成功====',fileList)
        //     this.filesForm.file = fileList

        //     if(this.filesForm.file.length > 0) {
        //         this.$refs['filesForm'].validateField('file')
        //     }
        // },

        // 删除文件
        // handleRemove(file , fileList) {
        //     console.log('删除上传文件====',file,fileList)

        //     this.filesForm.file = fileList

        //     // if(this.filesForm.file.length == 0) { 
        //     //     this.$refs['filesForm'].validateField('file')
        //     // }
        // },

        // 本地上传失败
        // handleError(err) {
        //     console.log('上传失败==',err)
        //     this.$message({
        //         message: '上传失败',
        //         type: 'error'
        //     })
        // },

        // 超出上传数量限制
        // handleExceed() {
        //     this.$message.warning('最多只能上传'+ this.maxNum +'个文件')
        // }
    }
}
</script>

<style lang="scss" scoped>
    .dialog{
        ::v-deep .el-dialog{
            min-width: 600px;
            width: 40vw;
        }
       ::v-deep .el-dialog__body{
           padding: 10px 20px 30px;
       } 
       .filter-item{
           margin-bottom: 20px;
       }
       .el-form{
           height: calc(100vh - 50vh);
           overflow-x: hidden;
           overflow-y:auto;
       }
    }
</style>